import { D, formatMoney } from "@netkeep/fee-engine";
import type { DecimalString, VerificationStatus } from "@netkeep/fee-types";

/** Formats a decimal string as currency without passing through floats. */
export function money(value: DecimalString, currency = "USD"): string {
  return formatMoney(new D(value), currency);
}

export function percent(value: DecimalString | null): string {
  return value == null ? "—" : `${value}%`;
}

export function isNegative(value: DecimalString): boolean {
  return new D(value).isNegative() && !new D(value).isZero();
}

export function shortDate(iso: string | null): string {
  if (!iso) return "never";
  const d = new Date(iso.length === 10 ? `${iso}T00:00:00Z` : iso);
  return d.toLocaleDateString(undefined, { year: "numeric", month: "short", day: "numeric", timeZone: "UTC" });
}

export const VERIFICATION_LABEL: Record<VerificationStatus, string> = {
  VERIFIED: "Verified",
  UNVERIFIED: "Unverified",
  STALE: "Needs re-check",
  FLAGGED: "Flagged",
};

export const TRANSACTION_LABEL: Record<string, string> = {
  SHIPPED: "Shipped",
  LOCAL_PICKUP: "Local pickup",
  INVOICE: "Invoice",
  IN_PERSON: "In person",
};

export const TAX_COLLECTOR_LABEL: Record<string, string> = {
  MARKETPLACE: "Marketplace collects & remits",
  SELLER: "You collect & remit",
  NONE: "No sales tax",
};

export const VERIFICATION_TONE: Record<VerificationStatus, "accent" | "warning" | "negative"> = {
  VERIFIED: "accent",
  UNVERIFIED: "warning",
  STALE: "warning",
  FLAGGED: "negative",
};
